/* =========================================================
   BBQ RESCHER – MOBILE STICKY CTA CONTROLLER
   GLOBAL für product.grillkurs.

   Die Sticky-CTA erscheint erst, nachdem die komplette schwarze
   Buchungsbox nach oben aus dem Viewport gescrollt wurde.
   Während der mittlere Buchungs-CTA sichtbar ist, wird die feste
   Leiste ausgeblendet, damit mobil nie zwei Buchungs-CTAs gleichzeitig
   um Aufmerksamkeit konkurrieren. Ab dem großen Abschluss-CTA bleibt
   die Sticky-CTA bis zum Footer ausgeblendet.

   Der Shopify-Chat folgt exakt demselben Sichtbarkeitszustand über
   die zentrale Body-Klasse bbqr-mobile-sticky-visible:
   Sticky sichtbar = Chat sichtbar, Sticky ausgeblendet = Chat ausgeblendet.

   Die reale CTA-Höhe wird als zentrale CSS-Variable bereitgestellt.
   ========================================================= */

(function () {
  'use strict';

  if (window.BBQRMobileStickyController) {
    window.BBQRMobileStickyController.update();
    return;
  }

  var mobileQuery = window.matchMedia('(max-width: 640px)');
  var frameRequested = false;

  function syncStickyMetrics(sticky) {
    if (!sticky || !mobileQuery.matches) return;

    var stickyHeight = Math.ceil(sticky.getBoundingClientRect().height);

    if (stickyHeight > 0) {
      document.documentElement.style.setProperty(
        '--bbqr-mobile-sticky-height',
        stickyHeight + 'px'
      );
    }
  }

  function isInViewport(element, viewportHeight) {
    if (!element) return false;

    var rect = element.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < viewportHeight;
  }

  function updateStickyState() {
    frameRequested = false;

    var sticky = document.querySelector('.bbqr-mobile-sticky');
    var bookingBox = document.querySelector('.Product--bbqrCourse .Product__Info .Container');
    var middleBookingCta = document.querySelector('.bbqr-booking-cta');
    var finalCta = document.querySelector('.bbqr-final-cta');
    var shouldShow = false;

    if (sticky && bookingBox && mobileQuery.matches) {
      syncStickyMetrics(sticky);

      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var bookingPast = bookingBox.getBoundingClientRect().bottom <= 0;
      var middleBookingCtaVisible = isInViewport(middleBookingCta, viewportHeight);
      var beforeFinalCta = true;

      if (finalCta) {
        beforeFinalCta = finalCta.getBoundingClientRect().top >= viewportHeight;
      }

      shouldShow = bookingPast && !middleBookingCtaVisible && beforeFinalCta;
    }

    if (sticky) {
      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    if (document.body) {
      document.body.classList.toggle('bbqr-mobile-sticky-visible', shouldShow);
    }
  }

  function requestUpdate() {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(updateStickyState);
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  window.addEventListener('orientationchange', requestUpdate);

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', requestUpdate);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(requestUpdate);
  }

  document.addEventListener('shopify:section:load', requestUpdate);
  document.addEventListener('shopify:section:unload', requestUpdate);

  window.BBQRMobileStickyController = {
    update: requestUpdate
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', requestUpdate, { once: true });
  } else {
    requestUpdate();
  }
}());
